import { Injectable } from '@angular/core';
import { IID_FEASABILITY_REQUEST_IDENTIFIER } from '@common/interfaces/interfaceData';
import { AbstractInterfaceDataQuery } from '../interfaceDataModel';
import { StudioFattibilitaRequestStore } from './studioFattibilitaRequest.store';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
import { InterfaceDataQuery } from '../interfaceDataRegistry';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_FEASABILITY_REQUEST_IDENTIFIER)
export class StudioFattibilitaRequestQuery extends AbstractInterfaceDataQuery<IID_FEASABILITY_REQUEST_IDENTIFIER> {
  constructor(protected store: StudioFattibilitaRequestStore) {
    super(store);
  }
}
